import { NavLink, useNavigate } from 'react-router-dom';
import {
    IconChartBar,
    IconCoin,
    IconDashboard,
    IconGift,
    IconLogout,
    IconReceipt,
    IconServer,
    IconSettings,
    IconTag,
    IconUsers,
    IconWorld,
    IconUsersGroup,
} from '@tabler/icons-react';
import { useAuth } from '../../context/AuthContext';
import './Sidebar.scss';

const NAV_ITEMS = [
    { to: '/', label: 'Дашборд', icon: IconDashboard, end: true },
    { to: '/servers', label: 'Серверы', icon: IconServer },
    { to: '/customers', label: 'Клиенты', icon: IconUsers },
    { to: '/subscriptions', label: 'Подписки', icon: IconReceipt },
    { to: '/payments', label: 'Платежи', icon: IconCoin },
    { to: '/promo-codes', label: 'Промокоды', icon: IconTag },
    { to: '/pricing', label: 'Цены', icon: IconGift },
    { to: '/site-status', label: 'Статус сайта', icon: IconWorld },
    { to: '/metrics', label: 'Аналитика', icon: IconChartBar },
    { to: '/referrals', label: 'Рефералы', icon: IconUsersGroup },
];

export default function Sidebar() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout();
        navigate('/login', { replace: true });
    };

    return (
        <aside className="admin-sidebar">
            <div className="admin-sidebar__brand">
                <span className="admin-sidebar__logo">BP</span>
                <div>
                    <p className="admin-sidebar__title">BypassVPN АДМИН</p>
                </div>
            </div>

            <nav className="admin-sidebar__nav" aria-label="Навигация">
                {NAV_ITEMS.map(({ to, label, icon: Icon, end }) => (
                    <NavLink
                        key={to}
                        to={to}
                        end={end}
                        className={({ isActive }) =>
                            `admin-sidebar__link${isActive ? ' admin-sidebar__link--active' : ''}`
                        }
                    >
                        <Icon size={20} stroke={1.5} />
                        <span>{label}</span>
                    </NavLink>
                ))}
            </nav>

            <div className="admin-sidebar__footer">
                <div className="admin-sidebar__user">
                    <IconSettings size={18} stroke={1.5} />
                    <span>{user?.login || 'admin'}</span>
                </div>
                <button type="button" className="admin-sidebar__logout" onClick={handleLogout}>
                    <IconLogout size={18} stroke={1.5} />
                    <span>Выйти</span>
                </button>
            </div>
        </aside>
    );
}
